import { FC } from "react"
import classes from "./styles.module.scss"
import { classNames } from "@/shared/lib/helpers/classNames"

interface SidebarProps {
	children: React.ReactNode
	top: number
	isOpen: boolean
	py?: number
	px?: number
	animate?: "fade-up" | "fade-down" | "slide-left" | "slide-right"
	onClose?: () => void
}

export const Sidebar: FC<SidebarProps> = ({
	children,
	top,
	isOpen,
	animate = "fade-up",
	onClose,
	py = 0,
	px = 0,
}) => {
	if (!isOpen) return null

	const handleBackdropClick = () => {
		onClose?.()
	}

	const stopPropagation: React.MouseEventHandler<HTMLDivElement> = event => {
		event.stopPropagation()
	}

	return (
		<div
			className={classNames([classes.sidebar, isOpen ? classes.open : classes.closed])}
			style={{ top, left: 0, right: 0, bottom: 0, padding: `${py}px ${px}px` }}
			onClick={handleBackdropClick}
		>
			<div className={classNames([classes.content, classes[animate]])} onClick={stopPropagation}>
				{children}
			</div>
		</div>
	)
}
